import { Flex, Link, Text, Tooltip } from "@chakra-ui/react";
import StatusBadge from "components/badge/StatusBadge";
import { formatTime } from "constants/commonFunctions";
import { formatDateToDDMONTHNAMEYYYY } from "utils/common";

const STATUS = {
  active: "Active",
  inactive: "Inactive",
};

export const planColumns = [
  {
    Header: "UID",
    accessor: "uid",
    Cell: ({ value }) => <Text>{value || "-"}</Text>,
  },
  {
    Header: "Name",
    accessor: "name",
    Cell: ({ value, row }) => {
    const {_id, user_type, is_custom} = row.original || {}
      return <Flex align="center" justify={"center"}>
        <Link
          target="_blank"
          href={
            is_custom
            ? `${process.env.REACT_APP_HEXAHOME_BASE_URL}/custom-plan/?plan_id=${_id}`
            : `${process.env.REACT_APP_HEXAHOME_BASE_URL}/plans/${user_type}`
          }
          gap={1}
          display={'flex'}
          >
          <Text textDecor={'underline'}>{value}</Text>
          {is_custom && (
            <StatusBadge label={"Custom"} status={"paid"}  />
          )}
        </Link>
      </Flex>
  },
  },
  {
    Header: "User",
    accessor: "user_id",
    Cell: ({ value }) => (
      <Text>
        {value?.phone ? `${value?.first_name}(${value?.phone})` : "-"}
      </Text>
    ),
  },
  {
    Header: "Description",
    accessor: "description",
    Cell: ({ value }) => (
      <Tooltip label={value} hasArrow placement="top">
        <span>
          {value?.length > 15 ? `${value.substring(0, 30)}...` : value}
        </span>
      </Tooltip>
    ),
  },
  {
    Header: "User Type",
    accessor: "user_type",
    Cell: ({ value }) => (
      <Text>
        {value ? value.charAt(0).toUpperCase() + value.slice(1) : "-"}
      </Text>
    ),
  },
  {
    Header: "Category",
    accessor: "category",
    Cell: ({ value }) => (
      <Text>{value.charAt(0).toUpperCase() + value.slice(1)}</Text>
    ),
  },
  {
    Header: "Status",
    accessor: "status",
    Cell: ({ value }) => <StatusBadge status={STATUS[value] || "Unknown"} />,
  },
  {
    Header: "Created At",
    accessor: "created_at",
    Cell: ({ value }) => (
      <Text>
        {formatDateToDDMONTHNAMEYYYY(value)} {formatTime(value)}
      </Text>
    ),
  },
  {
    Header: "Updated At",
    accessor: "updated_at",
    Cell: ({ value }) => (
      <Text>
        {formatDateToDDMONTHNAMEYYYY(value)} {formatTime(value)}
      </Text>
    ),
  },
];
